import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import TableCus from '../../../Components/Table/TableCus';

export default function Intruksi() {
  const col = ['Judul Intruksi', 'Tanggal Dibuat' ]
  const row = ['jenis_prasarana', 'a']
  const [searchValue, setSearchValue] = useState('')
  const data = useSelector(state => state.data.intruksi)
  const [dataFiltered, setDataFiltered] = useState([])
  const [dataSearch, setDataSearch] = useState(dataFiltered)
  const [flag, setFlag] = useState(false)

  function handleSearch(e) {
    const value = e.target.value
    let updatedData = []
    setSearchValue(value)

    if (value.length) {
      updatedData = dataFiltered.filter(item => {
        const startsWith =
          item.jenis_prasarana.toLowerCase().startsWith(value.toLowerCase()) ||
          item.nama_bangunan.toLowerCase().startsWith(value.toLowerCase()) ||
          item.nama_ruang.toLowerCase().startsWith(value.toLowerCase())
        const includes =
          item.jenis_prasarana.toLowerCase().includes(value.toLowerCase()) ||
          item.nama_bangunan.toLowerCase().startsWith(value.toLowerCase()) ||
          item.nama_ruang.toLowerCase().startsWith(value.toLowerCase())
        if (startsWith) {
          return startsWith
        } else if (!startsWith && includes) {
          return includes
        } else return null
      })
      setDataSearch(updatedData)
      setSearchValue(value)
      setFlag(!flag)
    } else {
      setDataSearch(dataFiltered)
    }
  }

  return (
    <>
      <TableCus hapus='intruksi' setFlag={setFlag} flag={setFlag} setDataFiltered={setDataFiltered} dataSearch={dataSearch} setDataSearch={setDataSearch} dataFiltered={dataFiltered} data={data} handleSearch={handleSearch} searchValue={searchValue} col={col} row={row} url='/loged/intruksi/tambah-intruksi' urlDetail='/loged/intruksi/detail' addText='Tambah Intruksi' />
    </>
  );
}
